/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import { useSearchParams } from "next/navigation";
import { useMemo } from "react";

export interface UtmParams {
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
  referrer: string | null;
  landing_page: string | null;
}

/**
 * Hook to capture UTM parameters and referrer from the current URL
 * Used for lead attribution tracking
 */
export function useUtmParams(): UtmParams {
  const searchParams = useSearchParams();

  return useMemo(() => {
    // Only access window/document on client side
    const referrer =
      typeof document !== "undefined" ? document.referrer || null : null;
    const landing_page =
      typeof window !== "undefined" ? window.location.pathname : null;

    return {
      utm_source: searchParams.get("utm_source"),
      utm_medium: searchParams.get("utm_medium"),
      utm_campaign: searchParams.get("utm_campaign"),
      referrer,
      landing_page,
    };
  }, [searchParams]);
}
